document.addEventListener('alpine:init', () => {
  // Navigation dropdown — Tier 3 motion. Children stagger in (list-reveal) on open
  // and stagger out in reverse (list-dismiss) on close, via the choreography runtime.
  Alpine.data('navDropdown', () => ({
    isActive: false,
    visible: false, // kept true through the exit stagger so children can animate out

    open() {
      this.isActive = true;
      this.visible = true;
      this.$nextTick(() => this.$motion.run('list-reveal', this.$refs.dropdown));
    },

    close() {
      if (!this.isActive) return;
      this.isActive = false;
      this.$motion.run('list-dismiss', this.$refs.dropdown).then(() => {
        this.visible = false;
      });
    },

    toggle() {
      this.isActive ? this.close() : this.open();
    },
  }));
});
